import { render, staticRenderFns } from "./CadastroPermissoes.vue?vue&type=template&id=20a9afd2&"
import script from "./CadastroPermissoes.vue?vue&type=script&lang=js&"
export * from "./CadastroPermissoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports